import requestModule from '@/application/libs/requestModule'
import util from  '@/application/libs/util'

export default {
    fetchBatchData(){
        const { 
            DTMESCARD: P_DTMESCARD, 
            TPCONTRATO: P_IDTIPORESTRICAO 
        } = util.getFilterInSession();
        return requestModule.postRequest('getData', {
                FROM: "GETBATCH",
                PARAMS: {  P_DTMESCARD, P_IDTIPORESTRICAO }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getBatchScenario(NRGERACAOCARD){
        return requestModule.postRequest('getData', {
            FROM: "GETBATCHSCENARIO",
            PARAMS: {
                P_NRLOTE: NRGERACAOCARD
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getGenerationSummary(NRITGERACAOCARD){
        return requestModule.postRequest('getData', {
            FROM: "GETGENERATIONSUMMARY",
            PARAMS: {
                NRITGERACAOCARD
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getPublicationSummary(NRLOGINTCARDAMES){
        return requestModule.postRequest('getData', {
            FROM: "GETPUBLICATIONSUMMARY",
            PARAMS: {
                NRLOGINTCARDAMES
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getAgrupFili(){
        return requestModule.postRequest('getData', {
            FROM: "AGRUPFILI",
            PARAMS: {
                USER_QUERY: ""
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getFiliOper(LISTAGRUPFILI){
        return requestModule.postRequest('getData', {
            FROM: "FILIAGRUP",
            PARAMS: {
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                LISTAGRUPFILI: LISTAGRUPFILI,
                USER_QUERY: ""
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getService(LISTAGRUPFILI, LISTAFILIAL){
        return requestModule.postRequest('getData', {
            FROM: "SERVFILIAGRUP",
            PARAMS: {
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                LISTAGRUPFILI: LISTAGRUPFILI,
                LISTAFILIAL: LISTAFILIAL,
                USER_QUERY: ""
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getTypeCost(){
        return requestModule.postRequest('getData', {
            FROM: "TIPOCUSTO",
            PARAMS: {
                NMTIPOCUSTO: ""
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
    getDefaultTypeCostPla(){
        return requestModule.postRequest('getData', {
            FROM: "TIPOCUSTOPLA",
            PARAMS: { 
                CDFILIAL: util.getFilterInSession().CDFILIAL
            }
        }).then( response => {
            if(response && response.dataset && response.dataset.data && response.dataset.data.length) {
                const [ FIRST_RECORD ] = response.dataset.data;
                const { CDTIPOCUSTOPLA } = FIRST_RECORD;
                return CDTIPOCUSTOPLA;
            } else {
                return null;
            }
        });
    },
    getGrupProd(){
        return requestModule.postRequest('getData', {
            FROM: "GRUPPROD",
            PARAMS: {
                USER_QUERY: ""
            }
        }).then(response=>response.dataset && response.dataset.data);
    },
     getAgrupProd(){
        return requestModule.postRequest('getData', {
            FROM: "AGRUPPROD",
             PARAMS: {}
        }).then(response=>response.dataset && response.dataset.data);
    },
    getDefaultAgrupProd(){
        return requestModule.postRequest('getData', {
            FROM: "GRUPPROD_PARAMGERAL",
            PARAMS: {}
        }).then( resp => {
            if( resp && resp.dataset && resp.dataset.data) {
                let [ FIRST_RECORD ] = resp.dataset.data;
                const { CDGRUPPRODOTMCARD } = FIRST_RECORD;
                return CDGRUPPRODOTMCARD;
            } else {
                return null;
            }
        });
    },
    getLinkedScenario(DTMESCARD, IDTIPORESTRICAO, CDFILIAL, CDSERVFILI){
        return requestModule.postRequest('getData', {
            FROM: "CENARIOVINCULO",
            PARAMS: {DTMESCARD, IDTIPORESTRICAO, CDFILIAL, CDSERVFILI}
        }).then(response=>response.dataset && response.dataset.data);
    },
    getSceneryPublish( NRITGERACAOCARD ){
        return requestModule.postRequest('getData', {
            FROM: "CENARIOPUBLICAR",
            PARAMS: {NRITGERACAOCARD}
        }).then(response => response.dataset && response.dataset.data);
    },
    getCabecalhoExportLog( NRITGERACAOCARD ){
        return requestModule.postRequest('getData', {
            FROM: "CABECALHOEXPORTLOG",
            PARAMS: { NRITGERACAOCARD }
        }).then(response => response.dataset && response.dataset.data[0]);
    },
    getGenerationAlert( NRITGERACAOCARD ){
        return requestModule.postRequest('getData', {
            FROM: "GENERATIONALERT",
            PARAMS: { NRITGERACAOCARD }
        }).then(response => response.dataset && response.dataset.data);
    },

    getLinkedService( NRGERACAOCARD ) {
        return requestModule.postRequest('getData', {
            FROM: "LINKEDSERVICE",
            PARAMS: { NRGERACAOCARD }
        }).then(response => response.dataset && response.dataset.data);
    },

    newBatchProcedureCaller(objectNewBatch){
        return requestModule.postRequest('newBatch', 
            {
                OBJECTNEWBATCH: objectNewBatch,
                CDOPERADOR: util.getLocalVar('userData').CDOPERADOR,
                NRORG: util.getLocalVar("userData").NRORG,
                TPCONTRATO: util.getFilterInSession().TPCONTRATO
            }
        ).then(response=>response.dataset);
    },
    generateScenery( scenery ){
        return requestModule.postRequestOtmNode('optimizer', scenery);
    },

    publishScenery( scenery ){
        return requestModule.postRequestOtmNode('publish', scenery);
    },

    calculateAlert( params ){
        return requestModule.postRequestOtmNode('calculateAlert', params);
    },

    updateStatusItems( PARAMS ){
        return requestModule.postRequest('updateData', {
            FROM: 'UPDATE_STATUS_ITEMS',
            PARAMS
        });
    },

    saveChangedData(params, dataSourceName){
        return requestModule.postRequest('updateData', {
            FROM: dataSourceName,
            PARAMS: params,
        });
    },
    updateStatusItGeracaoCard(NRITGERACAOCARD, IDSTATUSGERACAO, NRCENARIOPUBLICAR, NRLOGINTCARDAMES){
        return requestModule.postRequest('updateData', {
            FROM: 'UPDATESTATUSITGERACAOCARD',
            PARAMS: {
                NRITGERACAOCARD,
                IDSTATUSGERACAO,
                NRCENARIOPUBLICAR,
                NRLOGINTCARDAMES
            }
        })
    },
}